<template>
  <VModal ref="modal" @modal:hidden="$emit('hide')" disable-backdrop-click>
    <div class="w-full max-w-lg mx-auto">
      <BaseCard @click.stop>
        <BaseCardBody>
          <WoocommerceApiForm :action="createWoocommerceApiService" @cancel="$refs.modal.close()" />
        </BaseCardBody>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
import BaseCard from 'Components/BaseCard.vue';
import { accountWoocommerceApiServicesClient } from '@/api/clients';
import WoocommerceApiForm from './WoocommerceApiForm.vue';

export default {
  components: {
    WoocommerceApiForm,
    BaseCard,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  methods: {
    async createWoocommerceApiService(formData) {
      try {
        await this.$store.dispatch('ui/accountThirdPartyServices/storeFromService', {
          accountId: this.accountId,
          formData,
          service: accountWoocommerceApiServicesClient.store,
        });

        this.$refs.modal.close();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
